import {
  Award, ShieldCheck, Star, Zap, HeartPulse, Trophy, Hand, Layers,
  Fingerprint, Sparkles, Info, Quote, ArrowRight, Cat, Dog, Rabbit,
} from 'lucide-react';

// Central icon map so mock data can reference icons by string name
const map = {
  Award, ShieldCheck, Star, Zap, HeartPulse, Trophy, Hand, Layers,
  Fingerprint, Sparkles, Info, Quote, ArrowRight,
  Cat, Dog, Rabbit,
  Horse: Trophy, // no dedicated horse icon in lucide; use Trophy as stand-in
};

export default function Icon({ name, ...props }) {
  const Cmp = map[name] || Sparkles;
  return <Cmp {...props} />;
}
